firebird.component('amInfoIcon', {
    bindings: {
        titleText: '@'
    },
    template:
        '<span class="info-icon" data-toggle="tooltip" data-placement="bottom" data-container="body" data-original-title="{{ ::ctrl.titleText }}">' +
        ' <img src="/img/redesign/icons/ic-info.svg" />' +
        '</span>',
    controllerAs: 'ctrl'
});
